import { useEffect, useState } from "react";

// 値が delay ms 変化しなくなってから反映する
export const useDebouncedValue = (value, delay) => {
    const [debounced, setDebounced] = useState(value);
    useEffect(() => {
        const timer = setTimeout(() => setDebounced(value), delay);
        return () => clearTimeout(timer);
    }, [value, delay]);
    return debounced;
};

export default useDebouncedValue;
